import { Inject, Injectable } from '@angular/core';
import { CONFIG_TOKEN, StorageToken } from 'core/constants';
import { IXMOptions } from 'core/interfaces';
import { SessionStorage } from 'services/storage/session';
import { HeroBannerInfo } from 'store/hero-banner/models';
import { LineBannerInfo } from 'store/line-banner/models';
import { SECONDARY_BANNER_IDS } from 'my-account/constants';
import { CbmPaymentContentUtil } from './cbm-payment-content';

@Injectable()
export class BannerService {
    private sessionStorage: SessionStorage;
    private config: IXMOptions;

    constructor(sessionStorage: SessionStorage, @Inject(CONFIG_TOKEN) config: IXMOptions) {
        Object.assign(this, { sessionStorage, config });
    }

    public setBannerButtonAction(currentBanner: CmsActivityBannerTemplate, bannerInfo: HeroBannerInfo | LineBannerInfo, 
        isExtendedUserRolesResi?: boolean, isMemberViewer?: boolean, isPrimary?: boolean, paymentGatewayUrl?: string): ButtonAttributes {
        const toReturn: ButtonAttributes = {
            uiSref: '',
            uiParams: {},
            href: '',
            hasButton: false,
            hasInternalLink: false,
            hasExternalLink: false,
            isSecondaryButton: SECONDARY_BANNER_IDS.includes(currentBanner.id)
        };

        if (!isPrimary && (currentBanner.id === 'account.payment.card.expiring' || (currentBanner.id === 'cb.account.payment.card.expiring' && !this.config.ENABLE_CBM_UNIFIED_WALLET))) {
            toReturn.hasButton = false;
        }  else if (isExtendedUserRolesResi && ((isPrimary && currentBanner.id === 'account.payment.card.expiring') || (!isMemberViewer && currentBanner.id === 'account.payment.failure'))) { 
            toReturn.href = currentBanner.ctaButton.link?.replace('[PAYMENT_BASE_URL]', paymentGatewayUrl);
            toReturn.hasExternalLink = true;
            toReturn.openInSameTab = true;
        } else if (this.config.ENABLE_CBM_UNIFIED_WALLET && (currentBanner.id === 'cb.account.payment.card.expiring' || currentBanner.id === 'cb.account.payment.failure')) {
            currentBanner.ctaButton.link = CbmPaymentContentUtil.selectPaymentUrl(
                currentBanner.ctaButton.cbmLinkSmb,
                currentBanner.ctaButton.cbmLinkOs
            );
            toReturn.href = CbmPaymentContentUtil.resolvePaymentUrl(
                currentBanner.ctaButton.link,
                this.config.CBM_PAYMENT_BASE_URL,
                this.sessionStorage.get(StorageToken.CBM_AUTH_GUID),
                this.sessionStorage.get(StorageToken.CBM_SITE_ID)
            );
            toReturn.hasExternalLink = true;
            toReturn.openInSameTab = true;
        } else if (currentBanner.ctaButton.internalRouteRef) {
            toReturn.uiSref = currentBanner.ctaButton.internalRouteRef.uiSref;
            const paramKeys: string[] = currentBanner.ctaButton.internalRouteRef.params;
            if (paramKeys) {
                paramKeys.forEach((paramKey: string) => {
                    const [ key, value ]: string[] = paramKey.split(':');
                    toReturn.uiParams[key] = bannerInfo.ctaButton[value];
                });
            }
            toReturn.hasInternalLink = true;
        } else if (currentBanner.ctaButton.internalConstRouteRef) {
            toReturn.uiSref = currentBanner.ctaButton.internalConstRouteRef.uiSref;
            const paramKeys: string[] = currentBanner.ctaButton.internalConstRouteRef.params;
            if (paramKeys) {
                paramKeys.forEach((paramKey: string) => {
                    const [ key, value ]: string[] = paramKey.split(':');
                    toReturn.uiParams[key] = value;
                });
            }
            toReturn.hasInternalLink = true;
        } else if (currentBanner.ctaButton.link) {
            toReturn.href = currentBanner.ctaButton.link;
            toReturn.hasExternalLink = true;
        } else if (currentBanner.ctaButton.action) {
            toReturn.hasButton = true;
        }

        return toReturn;
    }
}
